// 브라우저 언어 판별입니다.
//
// 번역문은 i18next 가 관리합니다(src/i18n/index.js, src/locales/*.json). 이 파일은
// "어떤 언어로 시작할지" 한 가지만 정하며, i18n 초기화가 이 함수를 씁니다.
// 판별 규칙을 두 곳에 두면 화면마다 언어가 갈릴 수 있으므로 여기만 고쳐 주세요.
//
// 예전에는 여기에 pickLabel(ko, en) 이 있어 내비게이션 라벨을 직접 골랐지만,
// 본문까지 다국어로 넓히면서 i18next 로 옮겼습니다.

// 제품이 한국어 기준이므로 판별에 실패하면 한국어로 둡니다.
export const isKorean = () => {
  if (typeof navigator === 'undefined') return true;
  const lang = navigator.language || navigator.userLanguage || '';
  // 'ko', 'ko-KR' 을 모두 받습니다. 값이 비어 있으면 판별 실패로 보고 한국어로
  // 둡니다. 이 절이 없으면 startsWith 가 false 라 영어로 떨어집니다.
  return lang.toLowerCase().startsWith('ko') || lang === '';
};
